/* src/app/features/tarefas/fgenergia/tarefas-fgenergia.component.scss */
h5 {
  margin-bottom: 40px;
}
.submit.col-auto {
  margin-top: 20px;
}
.d-flex.title {
  padding-right: 820px;
  font-weight: bold;
}
.d-flex.title2 {
  padding-right: 800px;
  font-weight: bold;
}
/*# sourceMappingURL=tarefas-fgenergia.component.css.map */
